import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import classesPropType from "@xo-union/classes-prop-type";
import cx from "classnames";
import { useClasses } from "@xo-union/react-css-modules";
import { OptionContainer, Option as CustomOption, OnFocusContainer } from "@xo-union/ui-select";
import styles from "./styles.css";
const Option = props => {
  const {
    onSelect,
    value,
    id,
    children,
    classes: classesProp,
    label,
    ...rest
  } = props;
  const classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(OptionContainer, {
    id: id,
    onSelect: onSelect,
    value: value
  }, option => {
    const containerClasses = cx(classes.container, {
      [classes['is-normal']]: !option.isActive && !option.isSelected,
      [classes['is-active']]: option.isActive,
      [classes['is-selected']]: option.isSelected
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OnFocusContainer, null, label || children || value), /*#__PURE__*/React.createElement(CustomOption, _extends({
      className: containerClasses
    }, rest), children || value));
  });
};
process.env.NODE_ENV !== "production" ? Option.propTypes = {
  /**
   * Override ID. Should be a static string that does not change.
   */
  id: PropTypes.string,
  /**
   * Called when option is selected
   */
  onSelect: PropTypes.func,
  /**
   * Contents to render. Falls back to given value
   */
  children: PropTypes.node,
  /**
   * Option value. Should be a static value that does not change
   */
  value: PropTypes.string.isRequired,
  /**
   * Set what gets rendered in dropdown when option is focused
   */
  label: PropTypes.node,
  /**
   * Classes API
   */
  classes: classesPropType(['container', 'checkmark', 'is-normal', 'is-active', 'is-selected'])
} : void 0;
export default Option;